<template>
    <div class="embed embed-typeform">
        <iframe
            v-if="url"
            :src="url"
            loading="lazy"
            width="100%"
            :height="height || '375'"
            frameborder="0"
            referrerpolicy="origin"
        />
    </div>
</template>

<script setup>
defineProps({
    url: {
        type: String,
        required: true,
        default: ''
    },
    height: {
        type: String,
        required: false,
        default: '375'
    }
});
</script>
<style lang="less" scoped>
.embed-typeform {
    @media @q-md-max {
        margin: 0 -1.5rem;
    }
}
</style>
